module.exports = __webpack_public_path__ + "img/schreiner_ocular.3521e67e.jpg";